import type { Language } from "../lib/localization";

export interface UpcomingModel {
  modelId: string;
  companyIds: readonly string[];
  expectedRelease: Record<Language, string>;
  /** Owner-highlighted forecasts run a light comet along the card's border. */
  outlined?: true;
  /** Cycle the organizations one at a time, logo and name together, instead
      of joining them in one label. */
  rotateCompanies?: true;
  /** Resolve the card's logo as if the model had this name, for codenames the
      logo rules cannot place (e.g. `GPT` for an OpenAI Arena codename). */
  logoModelName?: string;
}

export const UPCOMING_MODELS: readonly UpcomingModel[] = [
  {
    modelId: "fe-raichu(arena)",
    companyIds: ["openai"],
    expectedRelease: { en: "Leaked on Arena", zh: "在 Arena 上泄露" },
    outlined: true,
    logoModelName: "GPT"
  },
  {
    modelId: "dubi-mega(arena)",
    companyIds: ["deepseek"],
    expectedRelease: { en: "Leaked on Arena", zh: "在 Arena 上泄露" },
    outlined: true
  },
  {
    modelId: "fe-pichu(arena)",
    companyIds: ["openai", "microsoft-ai", "thinking-machines-lab"],
    expectedRelease: { en: "Leaked on Arena", zh: "在 Arena 上泄露" },
    outlined: true,
    logoModelName: "GPT",
    rotateCompanies: true
  },
  {
    modelId: "kalmia/qwen-4(arena)",
    companyIds: ["alibaba"],
    expectedRelease: { en: "Leaked on Arena", zh: "在 Arena 上泄露" },
    outlined: true,
    logoModelName: "Qwen"
  },
  {
    modelId: "kerria/qwen-4-flash(arena)",
    companyIds: ["alibaba"],
    expectedRelease: { en: "Leaked on Arena", zh: "在 Arena 上泄露" },
    outlined: true,
    logoModelName: "Qwen"
  },
  {
    modelId: "Claude Fable 5.5",
    companyIds: ["anthropic"],
    expectedRelease: { en: "Unknown", zh: "未知" },
    outlined: true
  },
  {
    modelId: "Muse Video",
    companyIds: ["meta-ai"],
    expectedRelease: { en: "Coming soon", zh: "即将推出" },
    outlined: true
  },
  {
    modelId: "Claude Opus 5.6",
    companyIds: ["anthropic"],
    expectedRelease: { en: "Unknown", zh: "未知" }
  },
  {
    modelId: "GPT-6.5 Bel",
    companyIds: ["openai"],
    expectedRelease: { en: "Unknown", zh: "未知" }
  },
  {
    modelId: "GPT-6.1 Astra",
    companyIds: ["openai"],
    expectedRelease: { en: "Unknown", zh: "未知" }
  },
  {
    modelId: "GPT-6.2 Sol",
    companyIds: ["openai"],
    expectedRelease: { en: "Unknown", zh: "未知" }
  },
  {
    modelId: "Seedance 3.0",
    companyIds: ["bytedance"],
    expectedRelease: { en: "Second half of 2026", zh: "2026年下半年" }
  },
  {
    modelId: "GLM-5.5-Flash",
    companyIds: ["z-ai"],
    expectedRelease: { en: "Unknown", zh: "未知" }
  }
] as const;
